import { Button } from "@/components/ui/button";
import { Lock, ArrowLeft } from "lucide-react";

export default function AccessRestrictedPage() {
  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-6" data-testid="access-restricted-page">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.06)] border border-[#e2e8f0] p-10">
          <div className="h-16 w-16 rounded-2xl bg-[#4338ca]/10 flex items-center justify-center mx-auto mb-6">
            <Lock className="h-8 w-8 text-[#4338ca]" />
          </div>
          <h1 className="font-outfit text-2xl font-bold text-[#0f172a] mb-3">Private Beta Active</h1>
          <p className="text-sm text-[#64748b] leading-relaxed mb-6">
            BizFlowa is currently accessible to invite-only beta participants.
            If you are a Bizflowa client or have been invited to test the platform,
            please ask the BizFlowa team to whitelist your Gmail address.
          </p>
          <div className="flex items-center justify-center gap-3">
            <Button variant="outline" onClick={() => window.location.href = "/login"} className="rounded-xl border-[#e2e8f0]">
              <ArrowLeft className="h-4 w-4 mr-2" /> Back to Login
            </Button>
          </div>
          <div className="mt-8 pt-6 border-t border-[#f1f5f9]">
            <div className="flex items-center justify-center gap-2 mb-3">
              <img src="/bizflowa-logo.png" alt="BizFlowa" className="h-6 w-6 rounded-lg object-contain" />
              <span className="font-outfit text-sm font-semibold text-[#94a3b8]">BizFlowa</span>
            </div>
            <div className="flex items-center justify-center gap-4 text-xs text-[#94a3b8]">
              <a href="/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#4338ca] transition-colors">Privacy Policy</a>
              <a href="/terms" target="_blank" rel="noopener noreferrer" className="hover:text-[#4338ca] transition-colors">Terms of Use</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
